import React from 'react';
import CSSModules from 'react-css-modules';
import { floor, calculatePercentage } from '../../helpers/math';
import Totaliser from '../Totaliser/Totaliser';
import styles from './Progress.scss';
import FormattedCurrency from 'src/components/FormattedCurrency';
import { FormattedMessage } from 'react-intl';

interface Props {
  raised: number;
  targetAmount: number;
  targetCurrency: Currency;
  totalCountSupporters: number;
}

const Progress = ({
  raised,
  targetAmount,
  targetCurrency,
  totalCountSupporters,
}: Props) => {
  const percentage = calculatePercentage(raised, targetAmount);
  const targetFloor = floor(targetAmount, 0);
  const raisedFloor = floor(raised, 0);

  return (
    <div styleName="progress">
      <Totaliser percentage={percentage} />
      <div styleName="target">
        <span className="jg-text--brand-large" styleName="raised">
          <FormattedCurrency
            value={raisedFloor}
            currency={targetCurrency}
            minimumFractionDigits={0}
            maximumFractionDigits={0}
          />
        </span>
        <span styleName="value">
          <FormattedMessage
            id="Progress.raisedOf"
            defaultMessage="raised of {target} target by {supporters}"
            values={{
              target: (
                <span className="jg-color--dark-orchid">
                  <b>
                    <FormattedCurrency
                      value={targetFloor}
                      currency={targetCurrency}
                      minimumFractionDigits={0}
                      maximumFractionDigits={0}
                    />
                  </b>
                </span>
              ),
              supporters: (
                <b>
                  <FormattedMessage
                    id="Progress.raisedOf.supporters"
                    defaultMessage="{supportersCount} {supportersCount, plural, one {supporter} other {supporters}}"
                    values={{
                      supportersCount: totalCountSupporters,
                    }}
                  />
                </b>
              ),
            }}
          />
        </span>
      </div>
    </div>
  );
};

export default CSSModules(Progress, styles);



// WEBPACK FOOTER //
// ./src/components/Page/Progress.tsx